import styled from 'styled-components'

export const Article = styled.article`
  padding: 30px;
  color: ${({ theme }) => theme.colors.black};
  padding: 22px 160px;
  ${({ theme }) => theme.media.desktop} {
    padding: 72px 60px;
  }
  ${({ theme }) => theme.media.tablet} {
    padding: 56px 32px;
    flex-direction: column;
  }
  ${({ theme }) => theme.media.phone} {
    padding: 22px 16px 56px;
    flex-direction: column;
  }
`

export const Header = styled.header`
  max-width: 1440px;
  margin: 0 auto;
  margin-bottom: 2.1875rem;
`

export const Content = styled.div`
  max-width: 1440px;
  margin: 0 auto;
`

export const Title = styled.h1`
  font-size: 1.75rem;
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.5rem;
  margin: 0;
`

export const MailTo = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
`
